import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import { ApproveDirectDepositFxn, getAllXtravelDirectDepositList } from '../actions/index'
import {
  anyNumberConvertInWord,
  DefaultTablePagination, displayDate, formatRupees
} from '../../../components/_utils/appUtils'
import { CheckMyRights } from '../../WebComponent/CheckUserRights'
import { ColumnWidth } from '../../WebComponent/columnWidth'
import DirectDepositDrawer from './addDirectDepositDrawer'
import { Popconfirm, Tooltip } from 'antd'

class xTravelDirectDepositList extends Component {

  events = {
    showAddDepositDrawer: () => {
      this.setState({
        visibleDepositDrawer: true
      })
    },
    hideAddDepositDrawer: () => {
      this.setState({
        visibleDepositDrawer: false
      })
    },
    reload: () => {
      this.tableRef.current.reload()
    },
    approveDeposit: async (depositData) => {
      let { dispatch } = this.props
      let resp = await dispatch(ApproveDirectDepositFxn(depositData))
      if (resp && resp.success) {
        if (this.tableRef && this.tableRef.current) {
          this.tableRef.current.reload()
        }
      }
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      visibleDepositDrawer: false
    }
    this.tableRef = React.createRef()
  }

  componentDidMount() {
    //use effect
  }

  apiRequest = (params) => {
    let { dispatch } = this.props
    return new Promise(async (resolve) => {
      let { data } = await dispatch(getAllXtravelDirectDepositList({
        ...params
      }))
      resolve(data)
    })
  }


  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => {
          return (
            <React.Fragment>
              {index + 1}
            </React.Fragment>
          )
        }
      },
      {
        title: 'Name',
        key: 'name',
        sorter: true,
        dataIndex: 'agentName',
        searchTextName: 'agentName',
        width: 200,
        render: (item, record) => {
          return (
            <ColumnWidth width={200}>
              {item} ({record.agentCompanyName})
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Amount',
        key: 'amount',
        dataIndex: 'amount',
        searchTextName: 'amount',
        width: 100,
        render: (item) => {
          return (
            <ColumnWidth width={100}>
              <Tooltip title={anyNumberConvertInWord(item)}>
                {formatRupees(item)}
              </Tooltip>
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        searchTextName: 'status',
        width: 100,
        render: (item, record) => {
          return (
            <ColumnWidth width={100}>
              {
                item == 'Pending' ?
                  <Tooltip title={'Approve Deposit'}>
                    <Popconfirm title={'Are your sure, you want to approve this record?'}
                                onConfirm={() => {
                                  this.events.approveDeposit(record)
                                }}>
                      <a className={'btn btn-default roundNew sm'}>
                        {item}
                      </a>
                    </Popconfirm>
                  </Tooltip> : item == 'Approved' ?
                  < a className={'btn btn-success-green roundNew sm'}>
                    {item}
                  </a> : ''
              }

            </ColumnWidth>
          )
        }
      },
      {
        title: 'Deposit Date',
        key: 'depositDate',
        dataIndex: 'depositDate',
        searchTextName: 'depositDate',
        width: 150,
        render: (item) => {
          return (
            <ColumnWidth width={150}>
              {displayDate(item)}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Receipt',
        key: 'receipt',
        dataIndex: 'receipt',
        width: 200,
        render: (item) => {
          if (!item) return null
          return (
            <ColumnWidth width={200}>
              <a href={item.url} target='_blank' rel='noopener noreferrer'>
                Receipt
              </a>
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Details',
        key: 'details',
        dataIndex: 'details',
        searchTextName: 'details',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={200}>
              {item}
            </ColumnWidth>
          )
        }
      }
    ]
    return (
      <div>

        <div className='row  mt-4'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='table-head d-flex align-items-center'>
                <h5>XTravelWorld Direct Deposit List</h5>
                <div className='search-box-table'>

                </div>

                <div className='sort-box-table mark-btn'>
                  <div>
                    <a className='btn' onClick={() => {
                      this.events.showAddDepositDrawer()
                    }}>
                      <img src={'../dist/icons/plus.png'} className={'plus'} /> Add Direct Deposit
                    </a>
                  </div>
                </div>

              </div>
              <div className='card-body table-responsive'>
                <TableComp columns={columns}
                           ref={this.tableRef}
                           pagination={DefaultTablePagination()}
                           apiRequest={this.apiRequest}
                           extraProps={{ scroll: { x: 1000 } }}
                />
              </div>
            </div>
            {this.state.visibleDepositDrawer ?
              <DirectDepositDrawer
                visible={this.state.visibleDepositDrawer}
                onClose={() => {
                  this.events.hideAddDepositDrawer()
                  this.events.reload()
                }}
                onSubmit={() => {
                  this.events.hideAddDepositDrawer()
                  this.events.reload()
                }} /> : null}

          </div>
        </div>
      </div>)

  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(xTravelDirectDepositList)
